import React, {use, useCallback, useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import {Link, useLocation, useParams} from "react-router-dom";
import SidebarMenuList from "../../includes/sidebarMenuList";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";

import {
    getAlertCountAPI,
    getTop7DayPerformerGainerLooserAPI,
    getTop7DayPerformerGainerLooserOneAPI,
} from "../../apihelper/profile";
import UserAvatar from "../userAvatar.js";
import {useNavigate} from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {Autocomplete, CircularProgress, TextField, useMediaQuery} from "@mui/material";
import json2mq from "json2mq";
import IconButton from "@mui/material/IconButton";
import Header3 from "../../common/header/Header3";
import "./portfolioAnalysis.css";
import {getmultiPortfolio} from "../../apihelper/portfolio";
import PortfolioChart from "./Chart/PortfolioChart";
import CompositionChart from "./Chart/CompositionChart";
// import {PerformanceCompositionTable} from "./Chart/PerformanceCompositionTable";
import {UnderperformerCurrently} from "./Chart/UnderperformerCurrently";
import {PerformanceCompositionTable} from "./Chart/PerformanceCompositionTable";
import Recommendation from "./Chart/Recommendation";
import PerformanceTable from "./Chart/PerformanceTable";
import {ReactComponent as NotificationIcon} from "../../pages/account/profile/profile_icon/notification-icon.svg";
import {useRef} from "react";
import {getPortfolioForGallery} from "../../apihelper/homepage.js";
import {tabLink} from "../../common/constant/tablink.jsx";
import BottomTab from "../../common/hooks/BottomTab.jsx";
import LoginPopUp from "../../common/alert/login/LoginPopUp.jsx";

const drawerWidth = 292;
const PortfolioAnalysis = (props) => {
    const {window1} = props;

    // get portfolio name
    const {prePortfolioName} = useParams();

    // get current path
    const location = useLocation();

    // check if path contains "my-portfolio/"
    const my_portfolio = location.pathname.includes("my-portfolio");

    // const {prePortfolioName, all_portfolio} = state || {};
    const navigate = useNavigate();
    const [unreadAlerts, setUnreadAlerts] = React.useState(0);
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const handleBackClick = () => navigate(-1);
    const [selectedPortfolio, setSelectedPortfolio] = React.useState();
    const [myPortfolio, setMyPortfolio] = React.useState([]);
    const [loadingMyPortfolio, setLoadingMyPortfolio] = React.useState(false);
    const [isLoginModalOpen, setLoginModalOpen] = useState(false);
    const [selectedPortfolioLoading, setSelectedPortfolioLoading] = React.useState(false);
    const container = window1 !== undefined ? () => window1().document.body : undefined;
    const [searchText, setSearchText] = useState("");
    const [textCopied, setTextCopied] = useState(false);

    useEffect(() => {
        setSearchText(prePortfolioName?.replace(/-/g, " "));
    }, [prePortfolioName]);

    const handleNavigate = (portfolio_name) => {
        const currentPath = location.pathname;
        const parts = currentPath.split("/");

        // Check if the path contains '/portfolio/:portfolioName/report' or '/my-portfolio/:prePortfolioName/report'
        if (parts.includes("portfolio") || parts.includes("my-portfolio")) {
            const routeIndex =
                parts.indexOf("portfolio") !== -1 ? parts.indexOf("portfolio") : parts.indexOf("my-portfolio");
            // Replace the portfolio name or prePortfolioName
            parts[routeIndex + 1] = portfolio_name.replace(/\s+/g, "-");
        } else {
            // If neither, we are in a different route, add the portfolio name
            parts.push(portfolio_name.replace(/\s+/g, "-"));
        }

        const newPath = parts.join("/");
        console.log("newPath", newPath);
        navigate(newPath);
    };

    const fetchData = useCallback(
        (sortKey, sortType) => {
            setLoadingMyPortfolio(true);
            console.log("my_portfolio0", my_portfolio, prePortfolioName);
            if (my_portfolio) {
                if (!selectedPortfolio) {
                    getmultiPortfolio({
                        user_id: userData?.user_id,
                        Token: userData?.token,
                    }).then((res) => {
                        if (res.code === "200") {
                            setMyPortfolio(res.data);
                            const slugArray = res.data[0]?.slugs.map((item) => item.slug);

                            const selectedPortfolioData =
                                prePortfolioName &&
                                res.data.find(
                                    (portfolio) => portfolio.portfolio_name === prePortfolioName?.replace(/-/g, " ")
                                );
                            console.log("MAtching found", prePortfolioName);
                            // If a matching portfolio is found, set it to the selected portfolio
                            if (prePortfolioName) {
                                const slugArray = selectedPortfolioData.slugs.map((item) => item.slug);
                                setSelectedPortfolio({
                                    portfolio_id: selectedPortfolioData.portfolio_type_id,
                                    portfolio_name: selectedPortfolioData.portfolio_name,
                                    total_portfolio_value: selectedPortfolioData.total_portfolio_value,
                                    cryptoList: slugArray,
                                });
                            } else {
                                setSelectedPortfolio({
                                    portfolio_id: res.data[0].portfolio_type_id,
                                    portfolio_name: res.data[0].portfolio_name,
                                    total_portfolio_value: res.data[0].total_portfolio_value,
                                    cryptoList: slugArray,
                                });
                            }

                            setLoadingMyPortfolio(false);
                        } else {
                            setLoadingMyPortfolio(false);
                            console.error("fetchdata1 is called 200 not");
                        }
                    });
                } else {
                    setLoadingMyPortfolio(false);
                }
            }
            if (!my_portfolio) {
                const user_id = userData ? userData.user_id : 0;
                setLoadingMyPortfolio(false);
                getPortfolioForGallery({
                    user_id: user_id,
                    search_text: searchText || "",
                    start_index: 0,
                    limit: `${7}`,
                    selected_hashtags: "",
                }).then((res) => {
                    if (res.code === "200") {
                        setMyPortfolio(res.data);

                        const slugArray = res.data[0]?.slugs.map((item) => item.slug);

                        const selectedPortfolioData =
                            prePortfolioName && res.data.find((portfolio) => portfolio.portfolio_name === searchText);
                        console.log(
                            "selectedPortfolioData",
                            selectedPortfolioData,
                            res.data,
                            prePortfolioName,
                            searchText
                        );

                        // If a matching portfolio is found, set it to the selected portfolio
                        if (
                            selectedPortfolioData ||
                            (prePortfolioName && prePortfolioName.replace(/-/g, " ") === searchText)
                        ) {
                            console.log("prePortfolioName", prePortfolioName, searchText);
                            const slugArray = selectedPortfolioData?.slugs.map((item) => item.slug);
                            setSelectedPortfolio({
                                portfolio_id: selectedPortfolioData.portfolio_id,
                                portfolio_name: selectedPortfolioData.portfolio_name,
                                total_portfolio_value: selectedPortfolioData.total_portfolio_value,
                                cryptoList: slugArray,
                            });
                            // } else if (res.data.length > 0 && !selectedPortfolio) {
                            //     setSelectedPortfolio({
                            //         portfolio_id: res.data[0].portfolio_id,
                            //         portfolio_name: res.data[0].portfolio_name,
                            //         total_portfolio_value: res.data[0].total_portfolio_value,
                            //         cryptoList: slugArray,
                            //     });
                        }

                        setLoadingMyPortfolio(false);
                    } else {
                        setLoadingMyPortfolio(false);
                        console.error("fetchdata1 is called 200 not");
                    }
                });
            }
        },
        [userData]
    );
    const [my7DaysPortfolio, setMy7DaysPortfolio] = useState();

    const fetchSevenDayPerformerData = useCallback(() => {
        if (!userData || !selectedPortfolio?.portfolio_id) {
            console.error("User data not available");
            return;
        }
        getTop7DayPerformerGainerLooserOneAPI(userData, selectedPortfolio?.portfolio_id)
        .then((res) => {
            if (res.code === 200) {
                setMy7DaysPortfolio(res.data);
                // setTableData(res.data["gainer_data"] || []);
            } else {
                setMy7DaysPortfolio(null);
                console.error("Fetch data error: response code not 200");
            }
            // setLoading(false);
        })
        .catch((error) => {
            console.error("Fetch data error:", error);
            // setLoading(false);
        });
    }, [userData, selectedPortfolio]);

    let url = "";
    React.useEffect(() => {
        fetchSevenDayPerformerData();
    }, [selectedPortfolio]);

    const handleLoginClick = () => {
        const originalUrl = window.location.pathname + window.location.search;
        sessionStorage.setItem("originalUrl", originalUrl);

        fetch(`${process.env.REACT_APP_API_URL}/initiategooglelogin?originalUrl=${encodeURIComponent(originalUrl)}`)
        .then((res) => res.json())
        .then((res) => {
            if (res.google_url) {
                window.location.replace(res.google_url); // Redirect to Google login
            } else {
                console.error("Failed to get Google login URL");
            }
        })
        .catch((err) => console.error("Error initiating login:", err));
    };

    const handleModalClose = () => {
        // Close the modal and reset the URL to the current page
        setLoginModalOpen(false);
        navigate("/portfolio-gallery", {replace: true});
    };

    const handleEditButtonClick = () => {
        const portfolioId = selectedPortfolio?.portfolio_id ?? "default_id"; // fallback to default if undefined
        const portfolioName = selectedPortfolio?.portfolio_name ?? "default_name";
        const encodedId = encodeURIComponent(portfolioId);
        const encodedName = encodeURIComponent(portfolioName.replace(/ /g, "-"));
        navigate(`/my-portfolio/${encodedId}/${encodedName}`);
    };

    const handleCopyButtonClick = () => {
        const portfolio_name = selectedPortfolio?.portfolio_name;
        const currentPath = location.pathname;
        const parts = currentPath.split("/");

        // Check for static routes "my-portfolio" and "portfolio"
        const staticRoutes = ["my-portfolio", "portfolio"];
        const lastSegment = parts[parts.length - 1];

        let newPath;

        // Check if we're on one of the two possible routes
        if (staticRoutes.includes(parts[1])) {
            // Update the prePortfolioName dynamically
            parts[parts.length - 2] = portfolio_name.replace(/\s+/g, "-"); // Update the prePortfolioName
            newPath = parts.join("/");
        } else {
            // If the route is not one of the static routes, just append the portfolio name
            newPath = [...parts, portfolio_name.replace(/\s+/g, "-")].join("/");
        }

        const fullUrl = `${window.location.origin}${newPath}`;

        // Copy the new URL to clipboard
        navigator.clipboard
        .writeText(fullUrl)
        .then(() => {
            console.log("Copied to clipboard:", fullUrl);
            setTextCopied(true);
            setTimeout(() => {
                setTextCopied(false);
            }, 2000); // Hide the "Copied" message after 2 seconds
        })
        .catch((err) => {
            console.error("Failed to copy:", err);
        });
    };

    React.useEffect(() => {
        fetchData();
    }, [searchText]);

    React.useEffect(() => {
        const userId = userData?.user_id || null;

        const fetchAlerts = async () => {
            const response = await getAlertCountAPI(userData?.user_id);
            if (response?.unread_notifications) {
                setUnreadAlerts(response?.unread_notifications);
            }
        };

        fetchAlerts();
    }, []);

    // const headerTabOptions = [
    //     {
    //         id: 1,
    //         text: "Go To Home Page",
    //         route: "/",
    //         icon: "home-icon.svg",
    //         color: "#FFB45C",
    //     },
    //     {
    //         id: 2,
    //         text: "Crypto Screener",
    //         route: "/crypto-screener",
    //         icon: "search-icon.svg",
    //         color: "#D2FD8B",
    //     },
    //     {
    //         id: 3,
    //         text: "Price Predictions",
    //         route: "/crypto-predictions",
    //         icon: "prediction-page-icon.svg",
    //         color: "#FFE144",
    //     },
    //     {
    //         id: 4,
    //         text: "Audit My Portfolio",
    //         route: userData ? "/my-portfolio" : "/audit-my-portfolio",
    //         icon: "audit-portfolio-icon.svg",
    //         color: "#48CEFF",
    //     },
    // ];

    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    const drawer = (
        <div className="d-flex flex-column h-100" style={{overflowY: "hidden"}}>
            <SidebarMenuList />
        </div>
    );

    const [inputValue, setInputValue] = useState(""); // Track input value

    useEffect(() => {
        // If the selected portfolio's name matches the current input value, set input to null
        if (selectedPortfolio?.portfolio_name) {
            setInputValue(""); // Reset input value when portfolio is selected
        }
    }, [selectedPortfolio]); // Run effect when selectedPortfolio changes

    const handleInputChange = (event, newInputValue) => {
        setInputValue(newInputValue || ""); // Allow typing freely
        setSearchText(newInputValue);
    };

    const [path, setPath] = useState("/");

    useEffect(() => {
        if (typeof window !== "undefined") {
            setPath(window.location.pathname);
        }
    }, []);

    const TopNavigationDesktop = ({unreadAlerts}) => {
        const isActive = (href) => path === href;

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: active ? "5px 13px" : "2px 13px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            color: active ? "#1877F2" : "#ffffff",
            fontWeight: active ? "600" : "500",
            fontSize: "16px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "20px", background: "#ffffff", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: "0 auto",
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            backgroundColor: "#1877F2",
                            padding: "5px 5px",
                            borderRadius: "50px",
                        }}
                    >
                        {/* My Profile */}
                        <Link
                            to={userData ? "/my-portfolio/detailed-portfolio-analysis" : "/audit-my-portfolio"}
                            style={{textDecoration: "none"}}
                        >
                            <div
                                style={topTabStyle(
                                    isActive(
                                        userData ? "/my-portfolio/detailed-portfolio-analysis" : "/audit-my-portfolio"
                                    )
                                )}
                            >
                                <img
                                    src={window.constants.asset_path + "/images/home-new.svg"}
                                    alt="home"
                                    style={{
                                        marginRight: "6px",
                                        filter: iconFilter(
                                            isActive(
                                                userData
                                                    ? "/my-portfolio/detailed-portfolio-analysis"
                                                    : "/audit-my-portfolio"
                                            )
                                        ),
                                    }}
                                />
                                {userData ? "My Portfolios" : "Portfolio Audit"}
                            </div>
                        </Link>

                        {/* My Portfolio */}
                        <Link style={{textDecoration: "none"}}>
                            <div style={topTabStyle(true)}>
                                <img
                                    src={window.constants.asset_path + "/images/portfolio_tab.svg"}
                                    alt="portfolio"
                                    style={{
                                        marginRight: "6px",
                                        filter: iconFilter(true),
                                    }}
                                />
                                {userData ? "Portfolio Report" : "Portfolio Audit"}
                            </div>
                        </Link>

                        {/* Farm Button - Always highlighted */}
                        <Link to="/reward-section" style={{textDecoration: "none"}}>
                            <div style={topTabStyle(isActive("/reward-section"))}>
                                <img
                                    src={window.constants.asset_path + "/images/search_tab.svg"}
                                    alt="portfolio"
                                    style={{
                                        marginRight: "6px",
                                        filter: iconFilter(isActive("/reward-section")),
                                    }}
                                />
                                Farm $WISD
                            </div>
                        </Link>
                    </div>

                    {/* Notification Bell */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: "5px",
                            marginRight: "15px",
                        }}
                    >
                        {/* Notification Bell */}
                        <div
                            onClick={() => (window.location.href = "/alerts")}
                            style={{position: "relative", cursor: "pointer"}}
                        >
                            <NotificationIcon className="notification-icon fa-2x" />
                             {/* Desktop */}
                        <div
                                style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "2px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "20px": "27px",
                                    height: unreadAlerts < 100 ? "20px": "27px",
                                    borderRadius: "50%",
                                    fontSize: "11px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "20px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                                >
                                {unreadAlerts < 100 ? unreadAlerts : "99+"}
                                </div>
                        </div>

                        <UserAvatar />
                    </div>
                </div>

                {/* Bottom Tabs */}
                <BottomTab
                    tabs={[tabLink["subscription"], tabLink["presale"], tabLink["profile"]]}
                    handleLoginClick={handleLoginClick}
                />
            </div>
        );
    };

    const TopNavigationMobile = ({unreadAlerts}) => {
        const isActive = (href) => path === href;

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: active ? "5px 8px" : "1px 8px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            textAlign: "left",
            color: active ? "#000" : "#ffffff",
            fontWeight: active ? "600" : "500",
            fontSize: "13px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "10px 5px", background: "#ffffff", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: 0,
                    }}
                >
                    <div
                        onClick={() => (window.location.href = "/my-portfolio/detailed-portfolio-analysis")}
                        style={{cursor: "pointer", marginTop: "0px", marginLeft: "10px"}}
                    >
                        <img
                            src={window.constants.asset_path + "/images/left-arrow.svg"}
                            alt="Back"
                            style={{width: "24px", height: "24px"}}
                        />
                    </div>
                    <div style={{display: "flex", alignItems: "center"}}>
                        {/* Notification Bell */}
                        <div
                            onClick={() => (window.location.href = "/alerts")}
                            style={{position: "relative", marginTop: "3px"}}
                        >
                            <NotificationIcon className="notification-icon fa-2x" />
                             {/* Mobile */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "7px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "18px" : "24px",
                                    height: unreadAlerts < 100 ? "18px" : "24px",
                                    borderRadius: "50%",
                                    fontSize: "10px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "18px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                            >
                               {unreadAlerts < 100 ? unreadAlerts : "99+"}
                            </div>
                        </div>
                        <UserAvatar />

                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="end"
                            onClick={handleDrawerToggle}
                            sx={{display: {sm: "none"}}}
                        >
                            <img
                                src="/images/menubar.svg"
                                alt="Menu Icon"
                                style={{
                                    width: "24px",
                                    height: "24px",
                                    marginRight: "10px",
                                    marginTop: "10px",
                                }}
                            />
                        </IconButton>
                    </div>
                </div>

                {/* Left Tabs */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "2px",
                        justifyContent: "space-between",
                        backgroundColor: "#1877F2",
                        padding: "5px 5px",
                        borderRadius: "50px",
                        fontSize: "12px",
                        minWidth: "270px",
                        textAlign: "center",
                        marginRight: "10px",
                    }}
                >
                    {/* My Profile */}
                    <Link
                        to={userData ? "/my-portfolio/detailed-portfolio-analysis" : "/audit-my-portfolio"}
                        style={{textDecoration: "none"}}
                    >
                        <div
                            style={topTabStyle(
                                isActive(userData ? "/my-portfolio/detailed-portfolio-analysis" : "/audit-my-portfolio")
                            )}
                        >
                            <img
                                src={window.constants.asset_path + "/images/home-new.svg"}
                                alt="home"
                                style={{
                                    marginRight: "5px",
                                    filter: iconFilter(
                                        isActive(
                                            userData
                                                ? "/my-portfolio/detailed-portfolio-analysis"
                                                : "/audit-my-portfolio"
                                        )
                                    ),
                                }}
                            />
                            {userData ? "My Portfolios" : "Portfolio Audit"}
                        </div>
                    </Link>

                    {/* My Portfolio */}
                    <Link
                        to={userData ? "/portfolio-analysis" : "/audit-my-portfolio"}
                        style={{textDecoration: "none"}}
                    >
                        <div style={topTabStyle(isActive(userData ? "/portfolio-analysis" : "/audit-my-portfolio"))}>
                            <img
                                src={window.constants.asset_path + "/images/portfolio_tab.svg"}
                                alt="portfolio"
                                style={{
                                    marginRight: "5px",
                                    filter: iconFilter(
                                        isActive(userData ? "/portfolio-analysis" : "/audit-my-portfolio")
                                    ),
                                }}
                            />
                            {userData ? "Reports" : "Portfolio Audit"}
                        </div>
                    </Link>

                    {/* Farm Button - Always highlighted */}
                    <Link to="/reward-transaction-history" style={{textDecoration: "none"}}>
                        <div style={topTabStyle(isActive("/reward-transaction-history"))}>
                            <img
                                src={window.constants.asset_path + "/images/search_tab.svg"}
                                alt="portfolio"
                                style={{
                                    marginRight: "5px",
                                    filter: iconFilter(isActive("/reward-transaction-history")),
                                }}
                            />
                            Farming
                        </div>
                    </Link>
                </div>

                {/* Bottom Tabs */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        gap: "10px",
                        marginTop: "25px",
                        marginRight: "10px",
                    }}
                >
                    <BottomTab
                        tabs={[tabLink["subscription"], tabLink["presale"], tabLink["profile"]]}
                        handleLoginClick={handleLoginClick}
                    />
                </div>
            </div>
        );
    };

    const inputRef = useRef(null);

    const [isFocused, setIsFocused] = useState(false);
    const [hasJustSelected, setHasJustSelected] = useState(false);
    const handleInputBlur = () => {
        setIsFocused(false);
    };

    const handleInputFocus = () => {
        setIsFocused(true);
        if (hasJustSelected) {
            setHasJustSelected(false); // reset flag, do not clear input
            return;
        }
        setInputValue(""); // clear input if not just selected
    };

    return (
        <div style={{width: "100vw", maxWidth: "100%", overflowX: "hidden"}}>
            <div className="d-flex row  w-100 m-0 mb-5">
                <Helmet>
                    <title>Portfolio Analysis</title>
                </Helmet>
                <Box
                    component="nav"
                    sx={{
                        width: "100%", // Take full width on mobile
                    }}
                    aria-label="mailbox folders"
                >
                    <Drawer
                        container={container}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true,
                        }}
                        sx={{
                            "& .MuiDrawer-paper": {
                                width: "280px", // Adjust width for mobile
                                backgroundColor: "white",
                                color: "#727376",
                            },
                        }}
                    >
                        {drawer}
                    </Drawer>
                </Box>
                {isLoginModalOpen && (
                    <LoginPopUp
                        isLoginModalOpen={isLoginModalOpen}
                        setLoginModalOpen={setLoginModalOpen} // Pass the state setter down
                        onClose={handleModalClose}
                    />
                )}
                <Header3 />
                <div className="profile-section col" style={{maxWidth: "100%"}}>
                    <div className="profile-container  profile-container-lg">
                        {/* Header Tabs */}
                        {/* {mediaQueryVar ? (
                            <div className="header-tabs d-flex justify-content-between">
                                {headerTabOptions.map((option) => (
                                    <a
                                        key={option.id}
                                        href={option.route}
                                        className="rounded-pill px-3 py-2 d-flex align-items-center "
                                        style={{backgroundColor: option.color}}
                                    >
                                        <img src={`images/profile_image/account_image/${option.icon}`} />
                                        <span className="tab-text pl-1">{option.text}</span>
                                    </a>
                                ))}
                            </div>
                        ) : null} */}

                        {/* Profile tabs */}
                        <div className="d-flex justify-content-between my-5">
                            {mediaQueryVar ? (
                                <>
                                    <div
                                        style={{
                                            position: "fixed",
                                            top: 0,
                                            left: drawerWidth, // aligns it to the right of the sidebar
                                            width: `calc(100% - ${drawerWidth}px)`, // takes full width minus sidebar
                                            backgroundColor: "#ffffff",
                                            zIndex: 1000,
                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                            height: "100px",
                                        }}
                                    >
                                        <TopNavigationDesktop unreadAlerts={unreadAlerts} />
                                    </div>
                                </>
                            ) : (
                                <div
                                    style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0, // aligns it to the right of the sidebar
                                        width: "100%", // takes full width minus sidebar
                                        backgroundColor: "#ffffff",
                                        zIndex: 1000,
                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                        height: "100px",
                                    }}
                                >
                                    <TopNavigationMobile unreadAlerts={unreadAlerts} />
                                </div>
                            )}
                        </div>

                        {/* section 1 */}
                        <div className="section">
                            <div className="d-flex gap-3">
                                <p className="label-1">Choose Portfolio</p>
                                <div className="custom-select-wrapper">
                                    <Autocomplete
                                        freeSolo
                                        disableClearable
                                        options={myPortfolio.map((item) => ({portfolio_name: item.portfolio_name}))}
                                        value={null} // No selected value
                                        inputValue={inputValue} // Controlled input value
                                        getOptionLabel={(option) =>
                                            typeof option === "string" ? option : option.portfolio_name
                                        }
                                        onInputChange={handleInputChange} // Handle input change
                                        onFocus={handleInputFocus} // Reset input when focused
                                        onChange={(event, newValue, reason) => {
                                            if (reason === "selectOption" && newValue) {
                                                const selected = myPortfolio.find(
                                                    (item) => item.portfolio_name === newValue.portfolio_name
                                                );
                                                if (selected) {
                                                    // navigate(`/portfolio/${selected.portfolio_name.replace(" ", "-")}`);
                                                    console.log("selected.portfolio_name", selected.portfolio_name);
                                                    handleNavigate(selected.portfolio_name);
                                                    setSelectedPortfolio({
                                                        portfolio_id: selected.portfolio_type_id,
                                                        portfolio_name: selected.portfolio_name,
                                                        total_portfolio_value: selected.total_portfolio_value,
                                                        cryptoList: selected.slugs.map((item) => item.slug),
                                                    });
                                                    setInputValue(selected.portfolio_name); // Show selected
                                                    setTimeout(() => {
                                                        inputRef.current?.blur(); // 👈 Remove focus after selection
                                                    }, 0);
                                                }
                                            } else {
                                                setSearchText(newValue);
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                inputRef={inputRef}
                                                placeholder={
                                                    isFocused
                                                        ? "" // no placeholder when focused
                                                        : selectedPortfolio?.portfolio_name
                                                        ? selectedPortfolio.portfolio_name.charAt(0).toUpperCase() +
                                                          selectedPortfolio.portfolio_name.slice(1)
                                                        : "Choose Portfolio"
                                                }
                                                onBlur={handleInputBlur}
                                                inputProps={{
                                                    ...params.inputProps,
                                                    readOnly: loadingMyPortfolio, // Prevent typing if loading
                                                    style: {
                                                        color: "#000000",
                                                    },
                                                }}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        appearance: "none",
                                                        WebkitAppearance: "none",
                                                        MozAppearance: "none",
                                                        background: "transparent",
                                                        padding: mediaQueryVar ? "2px 10px" : "1px 10px",
                                                        fontWeight: "700",
                                                        fontSize: mediaQueryVar ? "20px" : "18px",
                                                        borderRadius: "20px",
                                                        border: "1.8px solid rgba(24, 119, 242, 1)",
                                                        width: "100%",
                                                        color: "#000000",
                                                        maxWidth: "400px",
                                                        cursor: "pointer",
                                                    },
                                                    "& .MuiOutlinedInput-notchedOutline": {
                                                        border: "none",
                                                    },
                                                    "& .MuiOutlinedInput-input": {
                                                        padding: "0px",
                                                        "&::placeholder": {
                                                            color: "#000000",
                                                            opacity: 1,
                                                        },
                                                    },
                                                }}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <img
                                                            src={window.constants.asset_path + "/images/dropdown.png"}
                                                            alt="open_in"
                                                            width={30}
                                                            height={30}
                                                            style={{marginRight: "0px"}}
                                                        />
                                                    ),
                                                }}
                                            />
                                        )}
                                    />
                                    {loadingMyPortfolio && (
                                        <CircularProgress
                                            size={20}
                                            style={{
                                                position: "absolute",
                                                top: "25%",
                                                right: "4rem",
                                                transform: "translateY(-50%)",
                                                pointerEvents: "none",
                                            }}
                                        />
                                    )}
                                </div>
                            </div>

                            {/* Top gainer */}
                            <div
                                className="d-flex flex-column flex-md-row justify-content-center mt-5"
                                style={{
                                    marginRight: mediaQueryVar ? "5px" : "",
                                    alignItems: mediaQueryVar ? "center" : "",
                                }}
                            >
                                {/* {top7DayPerformer?.seven_days?.length > 0 && top7DayPerformer?.thirty_days?.length > 0 && ( */}
                                <>
                                    {" "}
                                    {my7DaysPortfolio?.gainer_data?.length > 0 && (
                                        <div
                                            className="d-flex justify-content-around top-gainer-card w-100"
                                            style={{marginBottom: mediaQueryVar ? "" : "20px"}}
                                        >
                                            <p>Top Gainer Last 7 Days</p>
                                            <img
                                                src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${my7DaysPortfolio?.gainer_data[0]?.crypto_id}.png`}
                                                alt="Gainer Icon"
                                            />
                                            {/* <p>{top7DayPerformer?.seven_days[0]?.slug}</p> */}
                                            <p>{my7DaysPortfolio?.gainer_data[0]?.slug}</p>
                                        </div>
                                    )}
                                    {my7DaysPortfolio?.looser_data?.length > 0 && (
                                        <div className="d-flex justify-content-around top-gainer-card w-100">
                                            <p>Top Loser Last 7 Days</p>
                                            <img
                                                src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${my7DaysPortfolio?.looser_data[0]?.crypto_id}.png`}
                                                alt="Gainer Icon"
                                            />
                                            {/* <p>{top7DayPerformer?.thirty_days[0]?.slug}</p> */}
                                            <p>{my7DaysPortfolio?.looser_data[0]?.slug}</p>
                                        </div>
                                    )}
                                </>
                                {/* )} */}
                            </div>

                            <div
                                style={{
                                    marginRight: mediaQueryVar ? "25px" : "",
                                    marginTop: mediaQueryVar ? "-30px" : "",
                                }}
                            >
                                <PortfolioChart
                                    selectedPortfolio={selectedPortfolio?.portfolio_name}
                                    portfolioId={selectedPortfolio?.portfolio_id}
                                />
                            </div>
                        </div>

                        {/* Ssection 2 */}
                        <div className="section2" style={{marginTop: mediaQueryVar ? "-30px" : ""}}>
                            <div style={{display: "flex", marginBottom: "30px", gap: "30px"}}>
                                <p className="label-2">COMPOSITION</p>

                                {my_portfolio ? (
                                    <button className="edit-btn" onClick={() => handleEditButtonClick()}>
                                        <strong>Edit The Portfolio</strong>
                                    </button>
                                ) : (
                                    <button className="edit-btn" onClick={() => handleCopyButtonClick()}>
                                        <strong>{textCopied ? "Copied" : "Copy The"} Portfolio</strong>
                                    </button>
                                )}
                            </div>
                            <CompositionChart portfolioId={selectedPortfolio?.portfolio_id} />
                        </div>

                        {/* Ssection 3 */}
                        <div className="section" style={{marginTop: mediaQueryVar ? "" : "30px"}}>
                            <div style={{display: "flex", marginBottom: "30px", gap: "30px"}}>
                                <p className="label-2">RECOMMENDATIONS FOR UNDERPERFORMERS</p>

                                {my_portfolio ? (
                                    <button className="edit-btn" onClick={() => handleEditButtonClick()}>
                                        <strong>Edit The Portfolio</strong>
                                    </button>
                                ) : (
                                    <button className="edit-btn" onClick={() => handleCopyButtonClick()}>
                                        <strong>{textCopied ? "Copied" : "Copy The"} Portfolio</strong>
                                    </button>
                                )}
                            </div>

                            <PerformanceTable
                                selectedPortfolio={selectedPortfolio?.portfolio_name}
                                portfolioId={selectedPortfolio?.portfolio_id}
                            />
                        </div>

                        {/* Ssection 4 */}
                        <div className="section">
                            <div style={{display: "flex", marginBottom: "30px", gap: "30px"}}>
                                <p className="label-2">PORTFOLIO COMPOSITION</p>

                                {my_portfolio ? (
                                    <button className="edit-btn" onClick={() => handleEditButtonClick()}>
                                        <strong>Edit The Portfolio</strong>
                                    </button>
                                ) : (
                                    <button className="edit-btn" onClick={() => handleCopyButtonClick()}>
                                        <strong>{textCopied ? "Copied" : "Copy The"} Portfolio</strong>
                                    </button>
                                )}
                            </div>
                            <div style={{marginRight: mediaQueryVar ? "20px" : ""}}>
                                <PerformanceCompositionTable
                                    selectedPortfolio={selectedPortfolio?.portfolio_name}
                                    selectedPortfolioId={selectedPortfolio?.portfolio_id}
                                    selectedTotalPortfolioValue={selectedPortfolio?.total_portfolio_value}
                                />
                            </div>
                        </div>

                        {/* Ssection 5 */}
                        <div className="section">
                            <div style={{display: "flex", marginBottom: "30px", gap: "30px"}}>
                                <p className="label-2">RECOMMENDATIONS FOR UNDERPERFORMERS</p>

                                {my_portfolio ? (
                                    <button className="edit-btn" onClick={() => handleEditButtonClick()}>
                                        <strong>Edit The Portfolio</strong>
                                    </button>
                                ) : (
                                    <button className="edit-btn" onClick={() => handleCopyButtonClick()}>
                                        <strong>{textCopied ? "Copied" : "Copy The"} Portfolio</strong>
                                    </button>
                                )}
                            </div>
                            <div style={{marginRight: mediaQueryVar ? "25px" : ""}}>
                                <UnderperformerCurrently
                                    portfolioName={selectedPortfolio?.portfolio_name}
                                    portfolioId={selectedPortfolio?.portfolio_id}
                                    cryptoList={selectedPortfolio?.cryptoList}
                                    my_portfolio={my_portfolio}
                                />
                            </div>
                        </div>

                        {/* Ssection 6 */}
                        <div className="section2">
                            <div style={{display: "flex", marginBottom: "30px", gap: "30px"}}>
                                <p className="label-2">RECOMMENDATIONS FOR UNDERPERFORMERS</p>
                                {my_portfolio ? (
                                    <button className="edit-btn" onClick={() => handleEditButtonClick()}>
                                        <strong>Edit The Portfolio</strong>
                                    </button>
                                ) : (
                                    <button className="edit-btn" onClick={() => handleCopyButtonClick()}>
                                        <strong>{textCopied ? "Copied" : "Copy The"} Portfolio</strong>
                                    </button>
                                )}
                            </div>
                            <div style={{marginRight: "10px"}}>
                                <Recommendation
                                    selectedPortfolio={selectedPortfolio?.portfolio_name}
                                    selectedPortfolioId={selectedPortfolio?.portfolio_id}
                                    cryptoList={selectedPortfolio?.cryptoList}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PortfolioAnalysis;
